<template>
	<div class='root'>
		<vipMeetingHeader/>
		<div class="container">
			<!-- <div class="search">
				<Select class='sh-select' placeholder='请选择生活馆' size='large' v-model="store">
			        <Option v-for="item in storeList" :value="item.StoreId" :key="item.StoreId">{{ item.StoreName }}</Option>
			    </Select>
			    <Button @click='goList' type='primary' size='large' class='button'>查询</Button>
			</div> -->
			<StoreList :List="storeList" @update:store="goList"></StoreList>
		</div>
		<Modal v-model='showAgreement' :mask-closable='false'>
			<div slot='header'><div class="header">{{content.Title}}</div></div>
			<div class="body">
				<div v-html='content.Content'></div>
			</div>
			<div slot='footer'>
				<div class='modal-footer'>
					<Checkbox v-model="agree">我已阅读，并同意以上规则</Checkbox>
					<Button :disabled='!agree' class='btn' type='primary' long @click='goNext'>下一步</Button>	
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
	import vipMeetingHeader from '@/components/header/vipMeetingHeader'
	import StoreList from '@/components/common/StoreList'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				store:'',
				storeList:[],
				showAgreement:false,
				agree:false,
				content:{},
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{
		},
		mixins:[],
		components: {
			vipMeetingHeader,
			StoreList,
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				'getVIPStoresAction',
				'getTipDetailAction',
			]),
			async initData(){
				let LifeVIP_010 = await this.getVIPStoresAction()
				this.storeList = LifeVIP_010 || []
				// this.content = await this.getTipDetailAction('Meeting_Vip_Agree')
			},
			goNext(){
				this.$router.push({
					path:'/vipmeeting/home',
					query:{
						storeId:this.store
					}
				})
			},
			async goList(newValue){
				if(newValue){
					this.store = newValue.StoreId
					// PriceType字段：null或0为金额，1为点数
					this.content = await this.getTipDetailAction(newValue.PriceType==1 ? 'Meeting_Vip_Agree' : 'Meeting_VipFree_Agree')
					this.showAgreement = true
				}
			},
		},
	}
</script>

<style lang='scss' scoped>
	.root {
		background-color: #eee;
	}
	.container {
		background-color: #eee;
		padding-top:1.2rem;
		display:block;
		width: 100%;
		// margin: 0 auto;
	}
	.search {
		display:flex;
	}
	.sh-select {
		width:320px;
	}
	.button {
		width:160px;
		margin-left:10px;
		border-radius:20px;
	}
	.header {
		text-align: center;
	}
	.modal-footer {
		display:flex;
		flex-direction: column;
		align-items: center;
		.btn {
			margin-top: 10px;
		}
	}
	@media (max-width: 768px){
		.container {
			padding-top:3rem;
		}
		.button {
			margin-left:0px;
			margin-top: 20px;
			width:200px;
		}
		.search {
			flex-direction: column;
			align-items: center;
		}
	}
</style>